var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgMore1118 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 28, height: 28, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M24.5 12.5h-9v-9a1.5 1.5 0 0 0-3 0v9h-9a1.5 1.5 0 0 0 0 3h9v9a1.5 1.5 0 1 0 3 0v-9h9a1.5 1.5 0 1 0 0-3Z", fill: "#666" }));
export { SvgMore1118 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI0LjUgMTIuNWgtOXYtOWExLjUgMS41IDAgMCAwLTMgMHY5aC05YTEuNSAxLjUgMCAwIDAgMCAzaDl2OWExLjUgMS41IDAgMSAwIDMgMHYtOWg5YTEuNSAxLjUgMCAxIDAgMC0zWiIgZmlsbD0iIzY2NiIvPjwvc3ZnPg==";
